var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin-expired",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 48,
    height: 48,
    transform: "translate(-1 -1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    transform: "translate(-1 26)",
    fill: "#dfdfdf",
    stroke: "#414143",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 18,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 46.8,
    height: 16.8,
    rx: 8.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Title",
    transform: "translate(6 27)",
    fill: "#414143",
    fontSize: 11,
    fontFamily: "PingFangTC-Semibold, PingFang TC",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\u5DF2\u903E\u671F")), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M27.706,25.932a9.058,9.058,0,0,0,3.919-5.973,8.911,8.911,0,0,0,.112-1.41c0-6.374-6.75-11.541-15.076-11.541S1.585,12.175,1.585,18.549a8.884,8.884,0,0,0,4.658,7.836c2.2,1.26,5.551,2.432,10.83,2.432,5.453,0,8.323-1.3,10.633-2.885",
    transform: "translate(6.241 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M16.661,7.008c8.326,0,15.076,5.167,15.076,11.541a8.9,8.9,0,0,1-.112,1.41,9.056,9.056,0,0,1-3.919,5.973c-2.31,1.582-5.18,2.885-10.633,2.885-5.279,0-8.628-1.172-10.83-2.432a8.884,8.884,0,0,1-4.658-7.836c0-6.374,6.75-11.541,15.076-11.541m0-1.2C7.686,5.808.385,11.524.385,18.549a10.231,10.231,0,0,0,.723,3.77,10.351,10.351,0,0,0,4.539,5.107,22.85,22.85,0,0,0,11.426,2.591c5.983,0,9.075-1.564,11.311-3.095a10.292,10.292,0,0,0,4.426-6.774,10.191,10.191,0,0,0,.127-1.6c0-7.025-7.3-12.741-16.276-12.741",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M17.822,14.594c4.854.363,8.846.525,11.542.6a14.984,14.984,0,0,1,1.92.547,10.9,10.9,0,0,0-3.181-4.7c-1.473,0-2.608.1-2.608.1a85.83,85.83,0,0,1-17.49.051s-1.258-.113-2.845-.1A10.815,10.815,0,0,0,2,15.863c.418-.16.868-.314,1.349-.449,1.222-.028,2.8-.126,4.84-.348,0,0,7.178-.656,9.633-.472",
    transform: "translate(6.241 -1)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M15.779,9.918a.345.345,0,0,1-.209-.062.181.181,0,0,1-.086-.15V5.634a.184.184,0,0,1,.086-.151.352.352,0,0,1,.209-.062h1.892a5.948,5.948,0,0,1,.979.074,3.043,3.043,0,0,1,.79.239,1.316,1.316,0,0,1,.549.458,1.306,1.306,0,0,1,0,1.383,1.472,1.472,0,0,1-.545.484,2.931,2.931,0,0,1-.782.275,4.631,4.631,0,0,1-.946.091h-.688c-.027,0-.041.01-.041.03V9.706a.182.182,0,0,1-.082.15.325.325,0,0,1-.2.062Zm1.2-2.372c0,.02.014.029.041.029h.614q1.081,0,1.081-.69a.483.483,0,0,0-.278-.469,1.964,1.964,0,0,0-.844-.139h-.573c-.027,0-.041.008-.041.024Z",
    transform: "translate(6.241 -1)",
    fill: "#07df80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M30.03,10.536c0-3.323,1.794-7.234-8.122-8.934A25.092,25.092,0,0,0,5.287,4.152c-3.305,1.7-1.754,6.291-1.754,6.291l12.72,1.564Z",
    transform: "translate(6.241 -1)",
    fill: "#00f288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M17.234,1.2a27.659,27.659,0,0,1,4.674.4c9.916,1.7,8.122,5.612,8.122,8.935l-13.777,1.47L3.533,10.443S1.982,5.851,5.287,4.151A23.974,23.974,0,0,1,17.234,1.2m0-1.2A25.2,25.2,0,0,0,4.693,3.108C1.4,4.839,1.748,8.909,2.4,10.827a1.2,1.2,0,0,0,.99.807L16.107,13.2a1.428,1.428,0,0,0,.146.008c.043,0,.085,0,.128-.006l13.776-1.471a1.2,1.2,0,0,0,1.073-1.193c0-.4.029-.813.06-1.255.211-3.04.5-7.2-9.179-8.862A28.923,28.923,0,0,0,17.234,0",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M17.721,13.312a79.414,79.414,0,0,0-8.649.472,27.861,27.861,0,0,1-7.044.234,1.59,1.59,0,0,1-1.216-.954C-.96,8.915,8.907,9.912,8.907,9.912a69.236,69.236,0,0,0,15.7-.051s9.867-1,8.1,3.152a1.59,1.59,0,0,1-1.216.954s-5.513.033-13.768-.655",
    transform: "translate(6.241 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M4.058,14.742a14.213,14.213,0,0,1-2.12-.131A2.176,2.176,0,0,1,.26,13.3a2.307,2.307,0,0,1,.146-2.406C2.031,8.681,8.262,9.242,8.968,9.315a69.3,69.3,0,0,0,15.574-.05c.713-.073,6.944-.634,8.57,1.577a2.309,2.309,0,0,1,.145,2.407,2.173,2.173,0,0,1-1.677,1.31c-.143.01-5.722.033-13.908-.649a79.214,79.214,0,0,0-8.539.47,42.7,42.7,0,0,1-5.075.362M6.584,10.4c-2.163,0-4.542.293-5.211,1.2-.145.2-.3.537-.009,1.225a1,1,0,0,0,.756.6A27.272,27.272,0,0,0,9,13.188a77.212,77.212,0,0,1,8.772-.474c8.13.678,13.657.658,13.714.653a.989.989,0,0,0,.668-.589c.293-.688.136-1.028-.009-1.225-.921-1.254-5.071-1.339-7.474-1.1a70.526,70.526,0,0,1-15.846.048C8.176,10.441,7.4,10.4,6.584,10.4",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M15.246,9.183a.3.3,0,0,1-.175-.051A.153.153,0,0,1,15,9.006V5.6a.15.15,0,0,1,.072-.126.29.29,0,0,1,.175-.052h1.582a4.858,4.858,0,0,1,.819.062,2.543,2.543,0,0,1,.661.2,1.114,1.114,0,0,1,.459.383,1.011,1.011,0,0,1,.164.58,1.026,1.026,0,0,1-.167.578,1.226,1.226,0,0,1-.456.4,2.46,2.46,0,0,1-.654.23,3.867,3.867,0,0,1-.791.077h-.576c-.023,0-.034.008-.034.024V9.006a.156.156,0,0,1-.068.126.281.281,0,0,1-.172.051ZM16.253,7.2c0,.016.011.025.034.025H16.8q.9,0,.9-.578a.4.4,0,0,0-.233-.392,1.635,1.635,0,0,0-.7-.116h-.48c-.023,0-.034.006-.034.019Z",
    transform: "translate(6.241 -1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M16.829,5.421a4.969,4.969,0,0,1,.818.062,2.563,2.563,0,0,1,.662.2,1.108,1.108,0,0,1,.458.382,1.1,1.1,0,0,1,0,1.158,1.233,1.233,0,0,1-.455.4,2.462,2.462,0,0,1-.656.229,3.853,3.853,0,0,1-.791.077h-.574c-.024,0-.035.008-.035.024V9.005a.155.155,0,0,1-.069.126.277.277,0,0,1-.17.052h-.767a.3.3,0,0,1-.175-.052A.153.153,0,0,1,15,9.005V5.6a.15.15,0,0,1,.072-.126.288.288,0,0,1,.175-.052Zm-.541,1.8H16.8c.6,0,.9-.193.9-.578a.4.4,0,0,0-.233-.392,1.638,1.638,0,0,0-.7-.116h-.479c-.024,0-.035.006-.035.02V7.2c0,.017.011.025.035.025m.541-3H15.247a1.49,1.49,0,0,0-.875.277A1.345,1.345,0,0,0,13.8,5.6V9.005a1.345,1.345,0,0,0,.571,1.1,1.49,1.49,0,0,0,.876.278h.767a1.476,1.476,0,0,0,.9-.3,1.349,1.349,0,0,0,.539-.984c.155-.017.305-.041.45-.071a3.676,3.676,0,0,0,.973-.345,2.438,2.438,0,0,0,.891-.8,2.29,2.29,0,0,0,0-2.493,2.3,2.3,0,0,0-.946-.8,3.735,3.735,0,0,0-.97-.3,6.192,6.192,0,0,0-1.018-.078",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M22.211,20.361a.58.58,0,0,1-.141-.018l-2.643-.633a.6.6,0,1,1,.281-1.166l2.643.633a.6.6,0,0,1-.14,1.184",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M11.748,23.489c-.039,0-.078,0-.117-.005a1.191,1.191,0,0,1-.879-.519c-.651-.927-.193-2.9-.1-3.29a.6.6,0,0,1,.47-.442l1.364-.258a.6.6,0,0,1,.709.54c.055.651.168,2.838-.648,3.64a1.131,1.131,0,0,1-.8.334m-.01-3.15a3.239,3.239,0,0,0,.009,1.953,4.231,4.231,0,0,0,.288-2.01Z",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M21.47,23.49a1.136,1.136,0,0,1-.8-.334c-.815-.8-.7-2.989-.648-3.641a.6.6,0,0,1,.71-.54l1.364.258a.6.6,0,0,1,.47.443c.1.386.556,2.363-.094,3.291a1.217,1.217,0,0,1-1,.523m-.287-3.207a3.822,3.822,0,0,0,.329,2.021,3.909,3.909,0,0,0-.031-1.964Z",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M10.97,20.361a.6.6,0,0,1-.14-1.184l2.643-.633a.6.6,0,1,1,.281,1.166l-2.643.633a.58.58,0,0,1-.141.018",
    transform: "translate(6.241 -1)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M18.361,22.419a.6.6,0,0,1-.329-.1l-1.455-.954-1.26.935a.6.6,0,0,1-.715-.965L16.535,19.9l2.156,1.413a.6.6,0,0,1-.33,1.1",
    transform: "translate(6.241 -1)",
    fill: "#414143"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinExpired);
export default __webpack_public_path__ + "static/media/pin-expired.0f85f0c312d164cccfed93220aef018f.svg";
export { ForwardRef as ReactComponent };